import { useFormik } from "formik";
import * as yup from "yup";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { requestSecureUrlActions } from "redux/actions/RequestSecureUrl/requestSecureUrlActions";
import { RootState } from "redux/rootReducer";

interface quickDonateTypes {
  phone: string;
  amount: string;
}

export const useQuickDonateFormik = (country: any, quickDonateData: any) => {
  const { t, i18n } = useTranslation();
  const dispatch: any = useDispatch();

  // accessing the user id
  const { loginData } = useSelector((state: RootState) => state.loginReducer);
  const userId = loginData?.user?.id || 0;

  const formik = useFormik({
    initialValues: {
      phone: "",
      amount: "",
    },

    validationSchema: yup.object({
      phone: loginData
        ? country === "eg"
          ? yup
              .string()
              .matches(
                /^(?:\+20|0)?(10|11|12|15)\d{8}$/,
                `${t("Invalid phone number")}`
              )
          : country === "uae"
          ? yup
              .string()
              .matches(
                /^(?:\+971|0)?(50|55|56|52|58)\d{7}$/,
                `${t("Invalid phone number")}`
              )
          : yup.string()
        : country === "eg"
        ? yup
            .string()
            .matches(
              /^(?:\+20|0)?(10|11|12|15)\d{8}$/,
              `${t("Invalid phone number")}`
            )
            .required(`${t("This field is required")}`)
        : country === "uae"
        ? yup
            .string()
            .matches(
              /^(?:\+971|0)?(50|55|56|52|58)\d{7}$/,
              `${t("Invalid phone number")}`
            )
            .required(`${t("This field is required")}`)
        : yup.string().required(`${t("This field is required")}`),
      amount: yup
        .number()
        .typeError(`${t("Amount must be a number")}`)
        .positive(`${t("Amount must be greater than zero")}`)
        .required(`${t("This field is required")}`),
    }),

    onSubmit: async (values: quickDonateTypes) => {
      // console.log("here");
      dispatch(
        requestSecureUrlActions(
          i18n.language,
          userId ? userId : 0,
          {
            device_info: null,
            projects: quickDonateData?.seasonal_project
              ? {
                  seasonal_projects: [
                    {
                      id: quickDonateData?.seasonal_project?.id,
                      amount: values.amount,
                    },
                  ],
                }
              : quickDonateData?.internal_project
              ? {
                  internal_projects: [
                    {
                      id: quickDonateData?.internal_project?.id,
                      amount: values.amount,
                    },
                  ],
                }
              : quickDonateData?.humanitarian
              ? {
                  humanitarian_projects: [
                    {
                      id: quickDonateData?.humanitarian?.id,
                      amount: values.amount,
                    },
                  ],
                }
              : quickDonateData?.campaign
              ? {
                  campaign_projects: [
                    {
                      id: quickDonateData?.campaign?.id,
                      amount: values.amount,
                    },
                  ],
                }
              : quickDonateData?.orphan
              ? {
                  orphan_projects: [
                    {
                      id: quickDonateData?.orphan?.id,
                      // duration: 0,
                      amount: values.amount,
                    },
                  ],
                }
              : {},
          },
          (urlLink: any) => {
            setTimeout(() => {
              window.open(`${urlLink?.message}`, "_blank");
              // dispatch({ type: "SET_SecureUrlData" });
            }, 1000);
          }
        )
      );
    },
  });

  return formik;
};
